module.exports = __webpack_public_path__ + "static/how-to-make-millions-with-your-ideas-5781c10914339c052f4da42d8e50b357.jpg";